var _defs, _g, _path, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVanWithCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 80",
    height: 80,
    width: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: #7ea7ac;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #4cb0d3;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: none;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-5, .cls-6, .cls-7 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke: #7ea7ac;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-miterlimit: 4;\r\n        stroke-width: 1px;\r\n      }\r\n\r\n      .cls-6, .cls-7 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke-miterlimit: 4;\r\n        stroke-width: 1px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.23,37.27l-93.92-.2-.1,23c0,1.1,.9,2.1,2.11,2.1l80.02,.2c.7,0,1.51-.1,2.22-.2l6.34-1c1.91-.4,3.33-2.1,3.33-4.1,0,0,0-19.8,0-19.8Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "63.22 58.37 75.81 58.37 75.81 36.07 84.71 35.87 83.79 62.67 63.01 62.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.73,41.27l-93.42,.2-.1-23c0-1.1,.9-2.1,2.1-2.1l79.59-.2c.7,0,1.5,.1,2.21,.2l6.31,1c1.9,.4,3.31,2.1,3.31,4.1,0,0,0,19.8,0,19.8Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "63.21 20.17 75.61 20.17 75.61 42.47 84.38 42.67 83.47 15.87 63.01 16.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 79.9,
    y: 10.82,
    width: 1.95,
    height: 4.89,
    transform: "translate(4.2 42.21) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.49,
    y: 65.92,
    width: 4.89,
    height: 1.51,
    transform: "translate(-17.28 103.43) rotate(-60)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85,16.25l8.5,2,2.5,2.5V59.25l-2.5,2.5-8.5,1.5m0-47h-4.5m4.5,0l-3-5-1.5-1-2.5,1,2.5,5m4.5,47h-4.5m4.5,0l-2.5,5.5-2,1-2.5-1,2.5-5.5m0-47H3.5l-2,2V61.75l2,1.5H80.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.5,58.25l8.5,5V16.75l-8.5,4m0,37.78V20.75m0,37.5h-13m-54.5,0H62.5m-54.5,0l-5.5,4m5.5-4v-18.5m0-19v19m0-19l-5-3.5m5,3.5H62.5m13,0h-13m0,37.5v5M1.5,39.75h6.5M62.5,15.75v5m33.5,2.5h2.5v6h-2.5v20.5h2.5v6.5h-2.5m2.02-32.11v4.16m0,22.42v4.61"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 40.85,
    y: 26.46,
    width: 0.3,
    height: 24.81,
    transform: "translate(-15.4 42.12) rotate(-46.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 28.59,
    y: 38.71,
    width: 24.81,
    height: 0.3,
    transform: "translate(-15.49 38.53) rotate(-43.13)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanWithCross);
export default __webpack_public_path__ + "static/media/van_with_cross.3085ac2bf6e90cebf78b047adcc33ba7.svg";
export { ForwardRef as ReactComponent };